var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"16578-development"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/16578-development";

import * as Sentry from '@sentry/nextjs';
import {Integrations} from '@sentry/nextjs';

const isDev = process.env.NODE_ENV === 'development';
const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
    dsn: isDev ? undefined : SENTRY_DSN,
    enabled: !isDev,
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampler: samplingContext => {
        if (samplingContext.transactionContext.name === '/[[...pages]]') {
            return 1;
        }
        if (samplingContext.transactionContext.name === 'NoTitle') {
            return 0.01;
        }
        if (samplingContext.transactionContext.name.includes('/api/auth/[...nextauth]')) {
            return 1;
        }
        if (samplingContext.transactionContext.name.includes('/payment')) {
            return 1;
        }
        return 1;
    },
    integrations: isDev ? [] : [new Integrations.BrowserTracing()],
});
